export const getPrettyName = ({ name }) => {
  if (name && (name.givenName || name.familyName)) {
    return `${name.givenName} ${name.familyName}`;
  }
  return '';
};
